// @generated by protoc-gen-es v1.10.0
// @generated from file ibc/core/channel/v1/tx.proto (package ibc.core.channel.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Channel, Packet, Params, State } from "./channel_pb.js";
import { Height } from "../../client/v1/client_pb.js";
import { ErrorReceipt, Upgrade, UpgradeFields } from "./upgrade_pb.js";

/**
 * ResponseResultType defines the possible outcomes of the execution of a message
 *
 * @generated from enum ibc.core.channel.v1.ResponseResultType
 */
export const ResponseResultType = /*@__PURE__*/ proto3.makeEnum(
  "ibc.core.channel.v1.ResponseResultType",
  [
    {no: 0, name: "RESPONSE_RESULT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "RESPONSE_RESULT_TYPE_NOOP", localName: "NOOP"},
    {no: 2, name: "RESPONSE_RESULT_TYPE_SUCCESS", localName: "SUCCESS"},
    {no: 3, name: "RESPONSE_RESULT_TYPE_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * MsgChannelOpenInit defines an sdk.Msg to initialize a channel handshake. It
 * is called by a relayer on Chain A.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelOpenInit
 */
export const MsgChannelOpenInit = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelOpenInit",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel", kind: "message", T: Channel },
    { no: 3, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelOpenInitResponse defines the Msg/ChannelOpenInit response type.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelOpenInitResponse
 */
export const MsgChannelOpenInitResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelOpenInitResponse",
  () => [
    { no: 1, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelOpenInit defines a msg sent by a Relayer to try to open a channel
 * on Chain B. The version field within the Channel field has been deprecated. Its
 * value will be ignored by core IBC.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelOpenTry
 */
export const MsgChannelOpenTry = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelOpenTry",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "previous_channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "channel", kind: "message", T: Channel },
    { no: 4, name: "counterparty_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "proof_init", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "proof_height", kind: "message", T: Height },
    { no: 7, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelOpenTryResponse defines the Msg/ChannelOpenTry response type.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelOpenTryResponse
 */
export const MsgChannelOpenTryResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelOpenTryResponse",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelOpenAck defines a msg sent by a Relayer to Chain A to acknowledge
 * the change of channel state to TRYOPEN on Chain B.
 * WARNING: a channel upgrade MUST NOT initialize an upgrade for this channel
 * in the same block as executing this message otherwise the counterparty will
 * be incapable of opening.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelOpenAck
 */
export const MsgChannelOpenAck = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelOpenAck",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "counterparty_channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "counterparty_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "proof_try", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "proof_height", kind: "message", T: Height },
    { no: 7, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelOpenAckResponse defines the Msg/ChannelOpenAck response type.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelOpenAckResponse
 */
export const MsgChannelOpenAckResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelOpenAckResponse",
  [],
);

/**
 * MsgChannelOpenConfirm defines a msg sent by a Relayer to Chain B to
 * acknowledge the change of channel state to OPEN on Chain A.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelOpenConfirm
 */
export const MsgChannelOpenConfirm = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelOpenConfirm",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "proof_ack", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "proof_height", kind: "message", T: Height },
    { no: 5, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelOpenConfirmResponse defines the Msg/ChannelOpenConfirm response
 * type.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelOpenConfirmResponse
 */
export const MsgChannelOpenConfirmResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelOpenConfirmResponse",
  [],
);

/**
 * MsgChannelCloseInit defines a msg sent by a Relayer to Chain A
 * to close a channel with Chain B.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelCloseInit
 */
export const MsgChannelCloseInit = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelCloseInit",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelCloseInitResponse defines the Msg/ChannelCloseInit response type.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelCloseInitResponse
 */
export const MsgChannelCloseInitResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelCloseInitResponse",
  [],
);

/**
 * MsgChannelCloseConfirm defines a msg sent by a Relayer to Chain B
 * to acknowledge the change of channel state to CLOSED on Chain A.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelCloseConfirm
 */
export const MsgChannelCloseConfirm = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelCloseConfirm",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "proof_init", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "proof_height", kind: "message", T: Height },
    { no: 5, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "counterparty_upgrade_sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * MsgChannelCloseConfirmResponse defines the Msg/ChannelCloseConfirm response
 * type.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelCloseConfirmResponse
 */
export const MsgChannelCloseConfirmResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelCloseConfirmResponse",
  [],
);

/**
 * MsgRecvPacket receives incoming IBC packet
 *
 * @generated from message ibc.core.channel.v1.MsgRecvPacket
 */
export const MsgRecvPacket = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgRecvPacket",
  () => [
    { no: 1, name: "packet", kind: "message", T: Packet },
    { no: 2, name: "proof_commitment", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "proof_height", kind: "message", T: Height },
    { no: 4, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgRecvPacketResponse defines the Msg/RecvPacket response type.
 *
 * @generated from message ibc.core.channel.v1.MsgRecvPacketResponse
 */
export const MsgRecvPacketResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgRecvPacketResponse",
  () => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(ResponseResultType) },
  ],
);

/**
 * MsgTimeout receives timed-out packet
 *
 * @generated from message ibc.core.channel.v1.MsgTimeout
 */
export const MsgTimeout = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgTimeout",
  () => [
    { no: 1, name: "packet", kind: "message", T: Packet },
    { no: 2, name: "proof_unreceived", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "proof_height", kind: "message", T: Height },
    { no: 4, name: "next_sequence_recv", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgTimeoutResponse defines the Msg/Timeout response type.
 *
 * @generated from message ibc.core.channel.v1.MsgTimeoutResponse
 */
export const MsgTimeoutResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgTimeoutResponse",
  () => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(ResponseResultType) },
  ],
);

/**
 * MsgTimeoutOnClose timed-out packet upon counterparty channel closure.
 *
 * @generated from message ibc.core.channel.v1.MsgTimeoutOnClose
 */
export const MsgTimeoutOnClose = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgTimeoutOnClose",
  () => [
    { no: 1, name: "packet", kind: "message", T: Packet },
    { no: 2, name: "proof_unreceived", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "proof_close", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "proof_height", kind: "message", T: Height },
    { no: 5, name: "next_sequence_recv", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "counterparty_upgrade_sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * MsgTimeoutOnCloseResponse defines the Msg/TimeoutOnClose response type.
 *
 * @generated from message ibc.core.channel.v1.MsgTimeoutOnCloseResponse
 */
export const MsgTimeoutOnCloseResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgTimeoutOnCloseResponse",
  () => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(ResponseResultType) },
  ],
);

/**
 * MsgAcknowledgement receives incoming IBC acknowledgement
 *
 * @generated from message ibc.core.channel.v1.MsgAcknowledgement
 */
export const MsgAcknowledgement = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgAcknowledgement",
  () => [
    { no: 1, name: "packet", kind: "message", T: Packet },
    { no: 2, name: "acknowledgement", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "proof_acked", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "proof_height", kind: "message", T: Height },
    { no: 5, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgAcknowledgementResponse defines the Msg/Acknowledgement response type.
 *
 * @generated from message ibc.core.channel.v1.MsgAcknowledgementResponse
 */
export const MsgAcknowledgementResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgAcknowledgementResponse",
  () => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(ResponseResultType) },
  ],
);

/**
 * MsgChannelUpgradeInit defines the request type for the ChannelUpgradeInit rpc
 * WARNING: Initializing a channel upgrade in the same block as opening the channel
 * may result in the counterparty being incapable of opening.
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeInit
 */
export const MsgChannelUpgradeInit = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeInit",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "fields", kind: "message", T: UpgradeFields },
    { no: 4, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelUpgradeInitResponse defines the MsgChannelUpgradeInit response type
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeInitResponse
 */
export const MsgChannelUpgradeInitResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeInitResponse",
  () => [
    { no: 1, name: "upgrade", kind: "message", T: Upgrade },
    { no: 2, name: "upgrade_sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * MsgChannelUpgradeTry defines the request type for the ChannelUpgradeTry rpc
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeTry
 */
export const MsgChannelUpgradeTry = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeTry",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "proposed_upgrade_connection_hops", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "counterparty_upgrade_fields", kind: "message", T: UpgradeFields },
    { no: 5, name: "counterparty_upgrade_sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "proof_channel", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 7, name: "proof_upgrade", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "proof_height", kind: "message", T: Height },
    { no: 9, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelUpgradeTryResponse defines the MsgChannelUpgradeTry response type
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeTryResponse
 */
export const MsgChannelUpgradeTryResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeTryResponse",
  () => [
    { no: 1, name: "upgrade", kind: "message", T: Upgrade },
    { no: 2, name: "upgrade_sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "result", kind: "enum", T: proto3.getEnumType(ResponseResultType) },
  ],
);

/**
 * MsgChannelUpgradeAck defines the request type for the ChannelUpgradeAck rpc
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeAck
 */
export const MsgChannelUpgradeAck = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeAck",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "counterparty_upgrade", kind: "message", T: Upgrade },
    { no: 4, name: "proof_channel", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "proof_upgrade", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "proof_height", kind: "message", T: Height },
    { no: 7, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelUpgradeAckResponse defines MsgChannelUpgradeAck response type
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeAckResponse
 */
export const MsgChannelUpgradeAckResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeAckResponse",
  () => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(ResponseResultType) },
  ],
);

/**
 * MsgChannelUpgradeConfirm defines the request type for the ChannelUpgradeConfirm rpc
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeConfirm
 */
export const MsgChannelUpgradeConfirm = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeConfirm",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "counterparty_channel_state", kind: "enum", T: proto3.getEnumType(State) },
    { no: 4, name: "counterparty_upgrade", kind: "message", T: Upgrade },
    { no: 5, name: "proof_channel", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "proof_upgrade", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 7, name: "proof_height", kind: "message", T: Height },
    { no: 8, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelUpgradeConfirmResponse defines MsgChannelUpgradeConfirm response type
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeConfirmResponse
 */
export const MsgChannelUpgradeConfirmResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeConfirmResponse",
  () => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(ResponseResultType) },
  ],
);

/**
 * MsgChannelUpgradeOpen defines the request type for the ChannelUpgradeOpen rpc
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeOpen
 */
export const MsgChannelUpgradeOpen = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeOpen",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "counterparty_channel_state", kind: "enum", T: proto3.getEnumType(State) },
    { no: 4, name: "counterparty_upgrade_sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "proof_channel", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "proof_height", kind: "message", T: Height },
    { no: 7, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelUpgradeOpenResponse defines the MsgChannelUpgradeOpen response type
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeOpenResponse
 */
export const MsgChannelUpgradeOpenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeOpenResponse",
  [],
);

/**
 * MsgChannelUpgradeTimeout defines the request type for the ChannelUpgradeTimeout rpc
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeTimeout
 */
export const MsgChannelUpgradeTimeout = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeTimeout",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "counterparty_channel", kind: "message", T: Channel },
    { no: 4, name: "proof_channel", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "proof_height", kind: "message", T: Height },
    { no: 6, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelUpgradeTimeoutResponse defines the MsgChannelUpgradeTimeout response type
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeTimeoutResponse
 */
export const MsgChannelUpgradeTimeoutResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeTimeoutResponse",
  [],
);

/**
 * MsgChannelUpgradeCancel defines the request type for the ChannelUpgradeCancel rpc
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeCancel
 */
export const MsgChannelUpgradeCancel = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeCancel",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "error_receipt", kind: "message", T: ErrorReceipt },
    { no: 4, name: "proof_error_receipt", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "proof_height", kind: "message", T: Height },
    { no: 6, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgChannelUpgradeCancelResponse defines the MsgChannelUpgradeCancel response type
 *
 * @generated from message ibc.core.channel.v1.MsgChannelUpgradeCancelResponse
 */
export const MsgChannelUpgradeCancelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgChannelUpgradeCancelResponse",
  [],
);

/**
 * MsgUpdateParams is the MsgUpdateParams request type.
 *
 * @generated from message ibc.core.channel.v1.MsgUpdateParams
 */
export const MsgUpdateParams = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgUpdateParams",
  () => [
    { no: 1, name: "authority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "params", kind: "message", T: Params },
  ],
);

/**
 * MsgUpdateParamsResponse defines the MsgUpdateParams response type.
 *
 * @generated from message ibc.core.channel.v1.MsgUpdateParamsResponse
 */
export const MsgUpdateParamsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgUpdateParamsResponse",
  [],
);

/**
 * MsgPruneAcknowledgements defines the request type for the PruneAcknowledgements rpc.
 *
 * @generated from message ibc.core.channel.v1.MsgPruneAcknowledgements
 */
export const MsgPruneAcknowledgements = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgPruneAcknowledgements",
  () => [
    { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "limit", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgPruneAcknowledgementsResponse defines the response type for the PruneAcknowledgements rpc.
 *
 * @generated from message ibc.core.channel.v1.MsgPruneAcknowledgementsResponse
 */
export const MsgPruneAcknowledgementsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.MsgPruneAcknowledgementsResponse",
  () => [
    { no: 1, name: "total_pruned_sequences", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "total_remaining_sequences", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

